"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _style = _interopRequireDefault(require("./style.css"));
var _sciencequest = _interopRequireDefault(require("./sciencequest.svg"));
var _thumbnail = _interopRequireDefault(require("./thumbnail.png"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = {
  name: 'Sky City',
  className: _style["default"].background,
  assets: [_sciencequest["default"]],
  imageUrl: _sciencequest["default"],
  thumbnail: _thumbnail["default"]
};